import React from 'react';
import ShowConvertion from 'components/Tvendo/Inventory/Operations/Convertions/ShowConvertion';
import NewConvertion from 'components/Tvendo/Inventory/Operations/Convertions/NewConvertion';
import { useParams } from 'react-router-dom';

export default function () {
  const { id } = useParams();

  if (parseInt(id) === 0) {
    return <NewConvertion />;
  }
  return <ShowConvertion />;
}
